/**
 * Tailwind class list that re-skins an AntD `<Select>` trigger so it matches
 * the in-house "sunken" form-input style (bg-surface-sunken, rounded, font-
 * medium, hover state). Used by consumers that swapped from the legacy
 * Radix-based Select primitive to AntD per the React 19 callback-ref
 * migration. Lives in `utils/` rather than alongside any one consumer
 * because the recipe is library-styling, not domain-specific.
 *
 * Vertical padding is intentionally NOT included — it differs per surface
 * (DetailsPanel form rows want `py-4`; tighter top-nav triggers like
 * IntervalPicker want `py-1.5`). Each caller appends its own padding class
 * literally so Tailwind JIT can extract it.
 *
 * Pair with `variant="borderless"` on the AntD Select to drop the default
 * outline before the sunken fill is applied.
 */
export const sunkenAntSelectClasses = [
  '[&_.ant-select-selector]:!h-auto',
  '[&_.ant-select-selector]:!rounded-md',
  '[&_.ant-select-selector]:!bg-surface-sunken',
  '[&_.ant-select-selector]:!px-4',
  '[&_.ant-select-selector]:!text-sm',
  '[&_.ant-select-selector]:!font-medium',
  '[&:hover_.ant-select-selector]:!bg-overlay-hover',
] as const;
